import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { CloudDownload, ErrorOutline, Print } from "@mui/icons-material";
import { Box, Button, Card, FormControlLabel, FormLabel, Grid, Icon, MenuItem, Radio, RadioGroup, TableFooter, TextField, styled } from "@mui/material";
import { Loader } from "app/components";
import { getAllConstructionNameListByParameters, getAllProjectLocationListForReportsByStatus } from "app/redux/actions/ProjectLocationActions";
import { getConstructionNameBOQContractReport, getConstructionNameBOQEstimateReport } from "app/redux/actions/ReportsAction";
import { AppConstants } from "app/utils/AppConstants";
import { ServiceUrl } from 'app/utils/Constants';
import { getStatusByRole, ProjectStatus } from 'app/utils/ProjectStatus';
import { SnackBarProperty } from "app/utils/SnackBarProperty";
import { addDynamicImage, captureHeader, checkValidation, currencyFormat, getTwoDigitDecimal } from "app/utils/utils";
import { SimpleCard } from "components";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import 'jspdf-autotable';
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { useDispatch, useSelector } from "react-redux";


const styles = {
  tableCell: {
    textAlign: "center"
  },
  subHeader: {
    textAlign: "center",
    fontWeight: 700
  }

}
const DecoratedTextField = styled(TextValidator)(() => ({
  width: "100%",
  marginBottom: "16px",
}));




export const ConstructionNameReport = ({state}) => {

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [reportType, setReportType] = useState("estimate")
  const [isDownloading, setIsDownloading] = useState(false)
  const [isPrinting, setIsPrinting] = useState(false)
  const [constructionNameList, setConstructionNameList] = useState([])
  const [projectDetails, setProjectDetails] = useState()
  const [totalAmount, setTotalAmount] = useState()
  const [tableData, setTableData] = useState()

  const showLoader = () => {
    setLoading(true)
  }
  const showToast = (msg) => {
    const key = enqueueSnackbar(msg ?? AppConstants.somethingWentWrong, { variant: 'error' });
    SnackBarProperty.error(key, closeSnackbar);
  }

  useEffect(() => {
    handleFormSubmit()
  },[reportType])

  const hideLoader = () => {
    setLoading(false)
  }
 
  const handleFormSubmit = () => {
    setTableData([])
    setLoading(true)
    if (reportType === "estimate") {
      const params = { construction_name_id: state?.constructionname_id, project_location_id: state?.project_location_id }
      getConstructionNameBOQEstimateReport(params)
        .then((res) => {
          setLoading(false)
          if (res?.status < 300) {
            if (res?.data?.obj && Object?.keys(res?.data?.obj)?.length > 0) {
              var rowIndex = 0
              const tableDataList = res?.data?.obj?.stageInformationList?.map((elem) => {
                const stage_name = elem?.stage_name
                const getTotalStageWise = (dataList) => {
                  const totalOfStage = dataList.reduce((acc, item) => acc + (getTwoDigitDecimal(item?.rate) * getTwoDigitDecimal(item?.quantity)), 0)
                  console.log("total of stage:", totalOfStage)
                  return totalOfStage
                }
                const dataList = elem?.constructionNameBOQDetailsList?.map((item, index) => {
                  rowIndex+=1
                  return {
                    sl_no: rowIndex,
                    bsr_ref_no: item?.item_code,
                    item_description: item?.item_description,
                    quantity: item?.quantity,
                    unit: item?.unit_name,
                    rate: item?.bsr_rate,
                    amount: parseFloat(item?.bsr_rate * item?.quantity).toFixed(2)

                  }
                })
                const obj = {
                  stageName: stage_name,
                  data: dataList,
                  total: getTotalStageWise(dataList)
                }
                return obj
              })
              const TotalAmount = res?.data?.obj?.stageInformationList?.reduce((accumulator, stage) => {
                const constructionNameBOQDetailsList = stage.constructionNameBOQDetailsList;
                const amountSum = constructionNameBOQDetailsList.reduce((acc, item) => acc + (item?.quantity * item?.bsr_rate), 0);
                return accumulator + amountSum;
              }, 0);
              setTotalAmount(TotalAmount)
              setProjectDetails({
                construction_name: res?.data?.obj?.construction_name,
                project_location: res?.data?.obj?.project_location,
                project_name: res?.data?.obj?.project_name,
                dzongkhag_name: res?.data?.obj?.dzongkhagName,
                bsr_year: res?.data?.obj?.bsr_year,
                header: res?.data?.obj?.header_logo,
                footer: res?.data?.obj?.footer_logo,
                costindex_percent: res?.data?.obj?.costindex_percent,
                // labour_costindex: res?.data?.obj?.labour_costindex,
                // material_costindex: res?.data?.obj?.material_costindex,
                cost_index_amount: res?.data?.obj?.cost_index_amount,
                classification_name: res?.data?.obj?.classification_name,
                description: res?.data?.obj?.description
              })
              setTableData(tableDataList)
            }
            else {
              const key = enqueueSnackbar(res?.data?.message, { variant: 'info' });
              SnackBarProperty.info(key, closeSnackbar);
            }
          }
          else {
            const key = enqueueSnackbar(res?.data?.message, { variant: 'error' });
            SnackBarProperty.error(key, closeSnackbar);

          }
        }).catch(error => {
          setLoading(false)

          const key = enqueueSnackbar(error?.response?.data?.errorMessage ?? AppConstants.somethingWentWrong, { variant: 'error' });
          SnackBarProperty.error(key, closeSnackbar);

        })
    }
    else {
      const params = { construction_name_id: state?.constructionname_id, project_location_id: state?.project_location_id }
      getConstructionNameBOQContractReport(params)
        .then((res) => {
          setLoading(false)
          if (res?.status < 300) {
            console.log(res.data)
            if (res?.data?.obj) {
              const tableDataList = res?.data?.obj?.stageInformationList?.map((elem) => {
                const stage_name = elem?.stage_name
                const getTotalStageWise = (dataList) => {
                  const totalOfStage = dataList.reduce((acc, item) => acc +  (getTwoDigitDecimal(item?.rate) * getTwoDigitDecimal(item?.quantity)), 0)
                  console.log("total of stage:", totalOfStage)
                  return totalOfStage
                }
                const dataList = elem?.constructionNameBOQDetailsList?.map((item, index) => {
                  return {
                    sl_no: index + 1,
                    bsr_ref_no: item?.item_code,
                    item_description: item?.item_description,
                    quantity: item?.quantity,
                    unit: item?.unit_name,
                    rate: item?.contract_rate,
                    amount: parseFloat(item?.contract_rate * item?.quantity).toFixed(2)

                  }
                })
                const obj = {
                  stageName: stage_name,
                  data: dataList,
                  total: getTotalStageWise(dataList)
                }
                console.log("obje:", obj)
                return obj
              })

              const TotalAmount = res?.data?.obj?.stageInformationList?.reduce((accumulator, stage) => {
                const constructionNameBOQDetailsList = stage.constructionNameBOQDetailsList;
                const amountSum = constructionNameBOQDetailsList.reduce((acc, item) => acc + (item?.contract_rate * item?.quantity), 0);
                return accumulator + amountSum;
              }, 0);
              setTotalAmount(TotalAmount)
              setProjectDetails({
                construction_name: res?.data?.obj?.construction_name,
                bsr_year: res?.data?.obj?.bsr_year,
                project_location: res?.data?.obj?.project_location,
                project_name: res?.data?.obj?.project_name,
                dzongkhag_name: res?.data?.obj?.dzongkhagName,
                header: res?.data?.obj?.header_logo,
                footer: res?.data?.obj?.footer_logo,
                costindex_percent: res?.data?.obj?.costindex_percent,
                // labour_costindex: res?.data?.obj?.labour_costindex,
                // material_costindex: res?.data?.obj?.material_costindex,
                cost_index_amount: res?.data?.obj?.cost_index_amount,
                description: res?.data?.obj?.description
              })
              setTableData(tableDataList)
            }
            else {
              const key = enqueueSnackbar(res?.data?.message, { variant: 'info' });
              SnackBarProperty.info(key, closeSnackbar);
            }
          }
          else {
            const key = enqueueSnackbar(res?.data?.message, { variant: 'error' });
            SnackBarProperty.error(key, closeSnackbar);

          }
        }).catch(error => {
          setLoading(false)
          console.log("error:", error)
          const key = enqueueSnackbar(error?.response?.data?.errorMessage ?? AppConstants.somethingWentWrong, { variant: 'error' });
          SnackBarProperty.error(key, closeSnackbar);

        })
    }
  }

  const handleDownload = (isPrint) => {
    if (isPrint) {
      setIsPrinting(true)
      setIsDownloading(false)
    }
    else {
      setIsPrinting(false)
      setIsDownloading(true)
    }
    const doc = new jsPDF();


      const headerHeight = checkValidation(projectDetails?.header) ? 35 : 15
      const textX = 15;
      const textY = headerHeight // Adjust the value for vertical separation

      // Add the text content below the header image
      doc.setFont('helvetica', 'bold'); // Set font to bold
      doc.setFontSize(12); // Set font size
      doc.text(`Bill of Quantities (${reportType === "estimate" ? "Estimate" : "Contract"}) - CNBOQ`, (doc.internal.pageSize.getWidth() / 2) - ((doc.getStringUnitWidth(`Bill of Quantities (${reportType === "estimate" ? "Estimate" : "Contract"}) - CNBOQ`) * doc.internal.getFontSize() / doc.internal.scaleFactor) / 2), textY);
      // doc.text(`Bill of Quantities (${reportType === "estimate" ? "Estimate" : "Contract"})`, textX, textY);
      doc.setFontSize(8); // Set font size
      const textWidth = doc.getStringUnitWidth("Construction Name:") * doc.internal.getFontSize() / doc.internal.scaleFactor;
      doc.text("Project Name:", textX, textY + 10);
      doc.setFont('helvetica', 'normal');
      doc.text(projectDetails?.project_name, textX + textWidth + 5, textY + 10);
      doc.setFont('helvetica', 'bold');
      doc.text("Construction Name:", textX, textY + 15);
      doc.setFont('helvetica', 'normal');
      doc.text(projectDetails?.construction_name, textX + textWidth + 5, textY + 15);
      doc.setFont('helvetica', 'bold');
      doc.text("Description:", textX, textY + 20);
      doc.setFont('helvetica', 'normal');
      doc.text(projectDetails?.description, textX + textWidth + 5, textY + 20);
      doc.setFont('helvetica', 'bold');
      doc.text("Dzongkhag:", textX, textY + 25);
      doc.setFont('helvetica', 'normal');
      doc.text(`${projectDetails?.dzongkhag_name}`, textX + textWidth + 5, textY + 25);
      doc.setFont('helvetica', 'bold');
      doc.text("BSR Year:", textX, textY + 30);
      doc.setFont('helvetica', 'normal');
      doc.text(`${projectDetails?.bsr_year}`, textX + textWidth + 5, textY + 30);

      const headerSectionHeight = headerHeight + 40; // Adjust the value as needed

      // Calculate the starting Y-coordinate for the table
      const tableStartY = headerSectionHeight + 5;
      doc.setFont('helvetica', 'normal');

      function transformData(data) {
        const transformedData = [];
        var rowIndex = 0
        data.forEach((section, index) => {

          // Create a row for the section header value (spanning across all 8 columns)
          const headerRow = [{ content: section.stageName, colSpan: 7, styles: { fontStyle: "bold", fontSize: 8 } }];
          transformedData.push(headerRow);

          // Loop through the data of the section and create rows for each object in the data

          section.data.forEach((row, index) => {
            rowIndex+=1
            const rowData = Object.values(row);

            const rate = currencyFormat(rowData?.amount)
            rowData.amount = rate// Extract values of each object

            transformedData.push([
              { content: rowIndex, styles: { fontSize: 8 } },
              { content: row?.bsr_ref_no, styles: { fontSize: 8 } },
              { content: row?.item_description, styles: { fontSize: 8 } },
              { content: currencyFormat(row?.quantity), styles: { fontSize: 8 } },
              { content: row?.unit ?? "", styles: { fontSize: 8 } },
              { content: currencyFormat(row?.rate), styles: { fontSize: 8 } },
              { content: currencyFormat(getTwoDigitDecimal(row?.rate) * getTwoDigitDecimal(row?.quantity)), styles: { fontSize: 8 } },
            ]);
          });
          transformedData.push([
            { content: `Sub-Total Amount (Nu) of ${section?.stageName}`, colSpan: 6, styles: { halign: "right", fontStyle: "bold", fontSize: 8 } },
            { content: `${currencyFormat(section?.total)}`, colSpan: 1, styles: { halign: "right", fontStyle: "bold", fontSize: 8 } },
          ])
        });
        return transformedData;
      }

      const transformedData = transformData(tableData);

      transformedData.push([{ content: reportType === "estimate" ? "Sub-Total Amount (Nu):" : "Total Amount (Nu):", colSpan: 6, styles: { halign: "right", fontStyle: "bold", fontSize: 8 } }, { content: currencyFormat(totalAmount), styles: { halign: "right", fontStyle: "bold", fontSize: 8 } }])
      if (reportType === "estimate") {
        transformedData.push([
          // { content: "Labour Cost Index (%):", colSpan: 2, styles: { halign: "left", fontStyle: "bold", fontSize: 8 } },
          // { content: currencyFormat(projectDetails?.labour_costindex), styles: { halign: "left", fontSize: 8 } },
          // { content: "Material Cost Index (%):", colSpan: 1, styles: { halign: "left", fontStyle: "bold", fontSize: 8 } },
          // { content: currencyFormat(projectDetails?.material_costindex), styles: { halign: "right", fontSize: 8 } },
          { content: "Cost Index (%):", colSpan: 1, styles: { halign: "left", fontStyle: "bold", fontSize: 8 } },
          { content: currencyFormat(projectDetails?.costindex_percent), styles: { halign: "right", fontSize: 8 } },
          { content: "Cost Index Amount (Nu):", colSpan: 2, styles: { halign: "left", fontStyle: "bold", fontSize: 8 } },
          { content: currencyFormat(projectDetails?.cost_index_amount), styles: { halign: "right", fontStyle: "bold", fontSize: 8 } }
        ])
        transformedData.push([
          { content: "Total Amount (Nu):", colSpan: 6, styles: { halign: "right", fontStyle: "bold", fontSize: 8 } },
          { content: currencyFormat(getTwoDigitDecimal(projectDetails?.cost_index_amount) + getTwoDigitDecimal(totalAmount)), styles: { halign: "right", fontStyle: "bold", fontSize: 8 } },

        ])
      }

      doc.autoTable({
          margin: { 
          top: 30,      // push below header
          bottom: 30    // leave space above footer
        },
        startY: tableStartY,
        head: [[
          { content: "SL NO.", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
          { content: "ITEM CODE", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
          { content: "ITEM DESCRIPTION", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
          { content: "QUANTITY", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
          { content: "UNIT", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
          { content: "RATE(Nu)", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
          { content: "AMOUNT(Nu)", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } }
        ]],
        body: transformedData, // Use the transformed data here
        theme: "grid",
        styles: {
          fillColor: [255, 255, 255], // Remove background color from the table
          lineColor: [0, 0, 0], // Set border color for main table
          lineWidth: 0.1, // Set border width for main table
          textColor: [0, 0, 0], // Set text color to black
          cellPadding: 2, // Add padding to cells
        },
        columnStyles: {
          2: { cellWidth: 50 }, // "ITEM DESCRIPTION" column width
          5: { halign: "right" }, // "RATE" column width
          6: { halign: "right" }, // "AMOUNT" column width
          3: { halign: "right" }, // "UNIT" column width
        },
      });

      // Get the total number of pages
          const totalNumPages = doc.internal.getNumberOfPages();
      
          // Loop through each page to add the footer with page numbers
          for (let i = 1; i <= totalNumPages; i++) {
      
            const pdfWidth = doc.internal.pageSize.getWidth() - 30;
      
            // Header
            const headerHeight = 20;
            const headerX = 15;
            const headerY = 0; // at the very top
            console.log('header name', projectDetails?.header)
            console.log('header name', projectDetails?.footer)
            if (checkValidation(projectDetails?.header)) {
              doc.addImage(
                `${ServiceUrl?.showImageUrl}${projectDetails?.header}`,
                headerX,
                headerY,
                pdfWidth,
                headerHeight
              );
            }
      
            //Footer
            const footerX = 15; // Starting X position for the footer
            const footerY = doc.internal.pageSize.getHeight() - 20; // 10 units from the bottom
            const footerHeight = 20;
            doc.setPage(i);
            if (checkValidation(projectDetails?.footer)) {
              doc.addImage(`${ServiceUrl?.showImageUrl}${projectDetails?.footer}`, footerX, footerY, pdfWidth, footerHeight)
            }
          }

      const scaleFactor = 1.0; // Adjust this value as needed
      const pdfBlob = doc.output('blob', { scale: scaleFactor });

      // Create a URL for the Blob
      const pdfUrl = URL.createObjectURL(pdfBlob);

      // Open a new window with the PDF URL

      if (isPrint) {
        const newWindow = window.open(pdfUrl, '_blank');

        // After the new window is opened, you can close the URL object
        URL.revokeObjectURL(pdfUrl);
        if (newWindow) {
          newWindow.onload = () => {
            setIsPrinting(false)
            setIsDownloading(false)
            // Wait for the window to load and then trigger the print dialog
            newWindow.print();
          };
        }
      }

      setIsPrinting(false)
      setIsDownloading(false)

      isPrint === false && doc.save(reportType === "estimate" ? 'ConstructionNameBoQ_Estimate_Report.pdf' : 'ConstructionNameBoQ_Contract_Report.pdf');

    // });
  };


  return (
    <>
      <div style={{ height: 'auto', width: "100%", display: "flex", flexDirection: "column", gap: "20px" }}>
        <SimpleCard>
          <ValidatorForm onSubmit={handleFormSubmit}>
            <Grid container spacing={3} style={{ marginTop: '-45px', marginBottom: '15px' }} >
              <Grid item xs={12}><b className="font20 extraBold" style={{ color: "#ebad4e" }}>Construction Name BoQ</b></Grid>
            </Grid>

            <Grid container spacing={3} >
              <Grid item xs={12}>
                <RadioGroup
                  row
                  name="reportType"
                  value={reportType}
                  onChange={(e) => { setReportType(e.target.value); setTableData([]) }}
                >

                  <FormControlLabel
                    label="Construction Name BoQ (Estimate)"
                    value="estimate"
                    control={<Radio size="small" color="secondary" />}
                    sx={{ mr: 3, height: 20 }}
                  />
                  <FormControlLabel
                    label="Construction Name BoQ (Contract)"
                    value="contract"
                    control={<Radio size="small" color="secondary" />}
                    sx={{ height: 20 }}
                  />
                </RadioGroup>

              </Grid>

             
              {/* <Grid item sm={4} xs={12}>
                <Button size="medium" color="success" variant="contained" type="submit" style={{ marginLeft: 4 }} >View</Button>
              </Grid> */}

            </Grid>

          </ValidatorForm>
        </SimpleCard>
        {tableData && tableData?.length > 0 && 
        <Grid container>
          <Grid xs={12} md={6}>
            {/* {checkValidation(projectDetails?.header) === false && <FormLabel sx={{ color: "#ff9800" }} color="warning">! Please upload header and footer for download/print</FormLabel>} */}
          </Grid>
          <Grid item xs={12} md={6}>
            <Box component="span" display="flex" justifyContent="flex-end">
              <Button
                size="small"
                // disabled={projectDetails?.header ? false : true}
                sx={{ width: "130px", marginLeft: 4 }}
                variant="contained"
                color="warning"
                startIcon={<CloudDownload />}
                onClick={() => { handleDownload(false) }}
              >
                Download
              </Button>
              <Button
                size="small"
                sx={{ width: "100px", marginLeft: 2 }}
                variant="contained"
                color="primary"
                // disabled={projectDetails?.header ? false : true}
                startIcon={<Print />}
                onClick={() => { handleDownload(true) }}
              >
                Print
              </Button>
            </Box>
          </Grid>

        </Grid>}
        {tableData && tableData?.length > 0 && <Card sx={{ padding: 3 }}>
          <div style={{ width: "100%", display: 'flex', flexDirection: "column", gap: "50px" }}>
            <div id="header" style={{ width: "100%", display: 'flex', flexDirection: "column", gap: "50px", paddingLeft: "100px", paddingRight: "100px" }}>
              <div style={{ width: "100%", display: "flex", justifyContent: "center", gap: "20px", alignItems: "center" }}>
                {checkValidation(projectDetails?.header) && 
                  <img id="headerLogo" src={`${ServiceUrl?.showImageUrl}${projectDetails?.header}`} style={{ height: "150px", width: "auto" }} alt="img" />
                }
              </div>

              <Grid container spacing={0} >
                <Grid item xs={12} align='center' >
                  <FormLabel sx={{ fontSize: 22 }} ><b>Bill of Quantities ({reportType === "estimate" ? "Estimate" : "Contract"}) - CNBOQ</b></FormLabel>
                </Grid>

                <Grid item xs={12} sx={{ marginTop: 2 }}>
                  <FormLabel sx={{ fontSize: 18 }}><b>Project Name: </b>{projectDetails?.project_name}</FormLabel>
                </Grid>
                <Grid item xs={12} >
                  <FormLabel sx={{ fontSize: 18 }}><b>Construction Name: </b>{projectDetails?.construction_name}</FormLabel>
                </Grid>
                <Grid item xs={12} >
                  <FormLabel sx={{ fontSize: 18 }}><b>Description: </b>{projectDetails?.description}</FormLabel>
                </Grid>
                <Grid item xs={12} >
                  <FormLabel sx={{ fontSize: 18 }}><b>Dzongkhag: </b>{projectDetails?.dzongkhag_name}</FormLabel>
                </Grid>
                <Grid item xs={12} >
                  <FormLabel sx={{ fontSize: 18 }}><b>BSR Year: </b>{projectDetails?.bsr_year}</FormLabel>
                </Grid>
              </Grid>
            </div>

            <div id="tableData">
              <TableContainer component={Paper}>
                <Table>
                  <TableHead style={{ backgroundColor: '#87CEEB' }}>

                    <TableRow>
                      <TableCell>Sl No.</TableCell>
                      <TableCell>ITEM CODE</TableCell>
                      <TableCell>ITEM DESCRIPTION</TableCell>
                      <TableCell>QUANTITY</TableCell>
                      <TableCell>UNIT</TableCell>
                      <TableCell>RATE (Nu)</TableCell>
                      <TableCell>AMOUNT (Nu)</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tableData?.map((section) => (
                      <React.Fragment key={section.stageName}>
                        <TableRow>
                          <TableCell colSpan={7}>{section.stageName}</TableCell>
                        </TableRow>
                        {section.data.map((row, index) => (
                          <TableRow key={index}>
                            <TableCell>{row.sl_no}</TableCell>
                            <TableCell>{row.bsr_ref_no}</TableCell>
                            <TableCell>{row.item_description}</TableCell>
                            <TableCell align="right">{currencyFormat(row.quantity)}</TableCell>
                            <TableCell>{row.unit}</TableCell>
                            <TableCell align="right">{currencyFormat(row.rate)}</TableCell>
                            <TableCell align="right">{currencyFormat(getTwoDigitDecimal(row?.rate) * getTwoDigitDecimal(row?.quantity))}</TableCell>
                          </TableRow>
                        ))}
                        <TableRow>
                          <TableCell colSpan={6} align="right">Sub-Total Amount (Nu) of {section.stageName} :</TableCell>
                          <TableCell align="right"><b>{currencyFormat(section?.total)}</b></TableCell>
                        </TableRow>
                      </React.Fragment>
                    ))}

                    <TableRow>
                      <TableCell colSpan={6} align="right" style={{ fontWeight: 300 }}>{reportType === "estimate" ? "Sub-Total Amount (Nu):" : "Total Amount (Nu):"}  ({projectDetails?.classification_name})</TableCell>
                      <TableCell colSpan={1} style={{ fontWeight: 600 }} align="right"><b>{currencyFormat(totalAmount)}</b></TableCell>
                    </TableRow>
                  </TableBody>

                </Table>
                {reportType === "estimate" && <Table>
                  <TableFooter>
                    <TableRow>
                      {/* <TableCell colSpan={2} align="right" style={{ fontWeight: 300 }}>Labour Cost Index (%):</TableCell>
                      <TableCell colSpan={1} style={{ fontWeight: 200 }} align="left">{currencyFormat(projectDetails?.labour_costindex)}</TableCell>
                      <TableCell colSpan={2} align="right" style={{ fontWeight: 300 }}>Material Cost Index (%):</TableCell>
                      <TableCell colSpan={1} style={{ fontWeight: 200 }} align="left">{currencyFormat(projectDetails?.material_costindex)}</TableCell> */}
                      <TableCell colSpan={2} align="right" style={{ fontWeight: 300 }}>Cost Index (%):</TableCell>
                      <TableCell colSpan={1} style={{ fontWeight: 200 }} align="left">{currencyFormat(projectDetails?.costindex_percent)}</TableCell>
                      <TableCell colSpan={2} align="right" style={{ fontWeight: 300 }}>Cost Index Amount (Nu):</TableCell>
                      <TableCell colSpan={1} style={{ fontWeight: 200 }} align="right">{currencyFormat(projectDetails?.cost_index_amount)}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={8} align="right" style={{ fontWeight: 400 }}>Total Amount (Nu):</TableCell>
                      <TableCell colSpan={1} style={{ fontWeight: 600 }} align="right"><b>{currencyFormat(getTwoDigitDecimal(projectDetails?.cost_index_amount) + getTwoDigitDecimal(totalAmount))}</b></TableCell>
                    </TableRow>
                  </TableFooter>
                </Table>}
              </TableContainer>

            </div>
          </div>
        </Card>}

      </div>
      {loading && (
        <Loader
          show={loading}
        />
      )}
      {(isPrinting || isDownloading) && (
        <Loader
          show={isPrinting ? isPrinting : isDownloading}
          text="Processing...Please wait."
        />
      )}

    </>
  )
}